import { useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { api } from '../api';

export default function Backup() {
  const queryClient = useQueryClient();
  const fileInput = useRef(null);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState(null);

  const download = async () => {
    setBusy(true);
    setMessage(null);
    try {
      const { blob, name } = await api.downloadBackup();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      setMessage({ type: 'success', text: `Sauvegarde téléchargée : ${name}` });
    } catch (e) {
      setMessage({ type: 'error', text: e.message });
    } finally {
      setBusy(false);
    }
  };

  const restore = async (e) => {
    const file = e.target.files[0];
    e.target.value = '';
    if (!file) return;
    if (!window.confirm(`Restaurer « ${file.name} » ?\n\nToutes les données actuelles (comptes, programmes, séances) seront remplacées par celles de la sauvegarde. Une copie de sécurité de l'état actuel est conservée sur le serveur.`)) return;
    setBusy(true);
    setMessage(null);
    try {
      await api.restoreBackup(file);
      queryClient.clear();
      alert('Base restaurée. Tu vas être reconnecté.');
      localStorage.removeItem('muscuapp_token');
      localStorage.removeItem('muscuapp_user');
      localStorage.removeItem('muscuapp_role');
      window.location.replace('/');
    } catch (err) {
      setMessage({ type: 'error', text: err.message });
      setBusy(false);
    }
  };

  return (
    <div>
      <div className="page-head">
        <div>
          <h1 className="page-title">Sauvegarde</h1>
          <p className="page-subtitle">Exporte ou restaure toute la base de données (comptes, programmes, séances, bibliothèque).</p>
        </div>
      </div>

      {message && <div className={`alert alert-${message.type === 'error' ? 'error' : 'success'}`}>{message.type === 'error' ? '⚠️ ' : '✅ '}{message.text}</div>}

      <div className="backup-grid">
        <div className="card">
          <div className="card-title">💾 Sauvegarder</div>
          <p className="muted small">Télécharge un fichier <code>.db</code> contenant l'état complet de la base à cet instant.</p>
          <button className="btn btn-primary" onClick={download} disabled={busy}>⬇️ Télécharger la sauvegarde</button>
        </div>
        <div className="card">
          <div className="card-title">♻️ Restaurer</div>
          <p className="muted small">Remplace toute la base par un fichier de sauvegarde. Les photos et vidéos envoyées ne font pas partie du fichier. Une copie de sécurité est gardée sur le serveur avant remplacement.</p>
          <input ref={fileInput} type="file" accept=".db,.sqlite,application/octet-stream" hidden onChange={restore} />
          <button className="btn btn-secondary" onClick={() => fileInput.current.click()} disabled={busy}>⬆️ Choisir un fichier…</button>
        </div>
      </div>
    </div>
  );
}
